import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="font-heading text-2xl font-bold text-primary-400">
                  被窝网
                </span>
                <span className="text-sm text-background-400 mt-1">电影</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                被窝网电影大全为您提供海量免费高清电影在线观看，聚合热门电影电视剧资源，最新全集不卡顿流畅播放，尽享舒适观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/dongzuo" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    动作片
                  </Link>
                </li>
                <li>
                  <Link to="/category/xiju" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    喜剧片
                  </Link>
                </li>
                <li>
                  <Link to="/category/kehuan" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    科幻片
                  </Link>
                </li>
                <li>
                  <Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    电视剧
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                热门推荐
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/movie/movie-1" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    流浪地球2
                  </Link>
                </li>
                <li>
                  <Link to="/movie/movie-2" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    满江红
                  </Link>
                </li>
                <li>
                  <Link to="/movie/movie-8" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    奥本海默
                  </Link>
                </li>
                <li>
                  <Link to="/movie/tv-1" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    狂飙
                  </Link>
                </li>
                <li>
                  <Link to="/movie/tv-2" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    三体
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    联系我们
                  </a>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-base" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2024 被窝网电影大全. 本站所有资源均来自互联网，仅供交流学习使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">
                免责声明
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}